<ng-template #strokeTypeImage let-strokeType>
  <svg viewBox="0 0 100 10" xmlns="http://www.w3.org/2000/svg">
    <line x1="10" y1="5" x2="90" y2="5" stroke-width="1" stroke-linecap="round"
    [attr.stroke-dasharray]="getDashArray(strokeType)"></line>
  </svg>
</ng-template>

<div class="styling-form">

  @if(showIconSettings()) {
    <mat-expansion-panel class="image-settings settings-section" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@core.drawing.icon">Icon</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="form-field form-field__columns">
        <label>{{ labelSize }}</label>
        <span>{{style.markerSize}}%</span>
      </div>
      <div class="form-field form-field__slider">
        <tm-slider [max]="200"
          [min]="50"
          [step]="25"
          [changeValueWhileSliding]="true"
          (valueChange)="changeMarkerSize($event)"
          [value]="style.markerSize"
          [label]="labelSize">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelRotation }}</label>
        <span>{{style.markerRotation}}&deg;</span>
      </div>
      <div class="form-field form-field__slider">
        <tm-slider [max]="360"
          [min]="0"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeMarkerRotation($event)"
          [value]="style.markerRotation"
          [label]="labelRotation">
        </tm-slider>
      </div>

    </mat-expansion-panel>

  }

  @if(showPointSettings()) {
    <mat-expansion-panel class="point-settings settings-section" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@core.drawing.symbol">Symbol</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.symbol">Symbol</label>
        <tm-icon-picker [icons]="getMarkers()"
          [selectedIcon]="getSelectedMarker()"
          [iconColor]="iconColor"
        (iconChange)="changeMarker($event)"></tm-icon-picker>
      </div>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.fill-color">Fill color</label>
        <tm-color-picker [color]="style.markerFillColor"
        (colorChange)="changeMarkerFill($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.line-color">Line color</label>
        <tm-color-picker [color]="style.markerStrokeColor"
        (colorChange)="changeMarkerStroke($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelLineThickness }}</label>
        <span>{{style.markerStrokeWidth}}px</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="10"
          [min]="1"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeMarkerStrokeWidth($event)"
          [value]="style.markerStrokeWidth"
          [label]="labelLineThickness">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelSize }}</label>
        <span>{{style.markerSize}}px</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="20"
          [min]="5"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeMarkerSize($event)"
          [value]="style.markerSize"
          [label]="labelSize">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelRotation }}</label>
        <span>{{style.markerRotation}}&deg;</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="360"
          [min]="0"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeMarkerRotation($event)"
          [value]="style.markerRotation"
          [label]="labelRotation">
        </tm-slider>
      </div>
    </mat-expansion-panel>
  }

  @if (showLabelSettings()) {
    <mat-expansion-panel class="label-settings settings-section" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@core.drawing.label">Label</mat-panel-title>
        <mat-panel-description>{{ labelControl.value }}</mat-panel-description>
      </mat-expansion-panel-header>

      <mat-form-field appearance="outline" color="primary">
        <mat-label i18n="@@core.drawing.label">Label</mat-label>
        @if (!isLabelType()) {
          <input matInput i18n-placeholder="@@core.drawing.label" placeholder="Label" [formControl]="labelControl">
        } @else {
          <textarea matInput i18n-placeholder="@@core.drawing.label" placeholder="Label" [formControl]="labelControl"></textarea>
        }
        <div matSuffix>
          @if (showInsertCoordinates()) {
            <button mat-icon-button
              tmTooltip="Insert coordinates as label"
              i18n-tmTooltip="@@core.drawing.insert-coordinates-label"
              (click)="insertCoordinates()">
              <mat-icon svgIcon="coordinates"></mat-icon>
            </button>
          }
          @if (isLineType()) {
            <button mat-icon-button
              tmTooltip="Insert length as label"
              i18n-tmTooltip="@@core.drawing.insert-length-label"
              (click)="insertLength()">
              <mat-icon svgIcon="tools_measure_length_outline"></mat-icon>
            </button>
          }
          @if (showInsertArea()) {
            <button mat-icon-button
              tmTooltip="Insert area as label"
              i18n-tmTooltip="@@core.drawing.insert-area-label"
              (click)="insertArea()">
              <mat-icon svgIcon="tools_measure_area_outline"></mat-icon>
            </button>
          }
        </div>
      </mat-form-field>

      <div class="form-field form-field__columns form-field__buttons">
        <label i18n="@@core.drawing.format">Format</label>
        <mat-button-toggle-group multiple="true">
          <mat-button-toggle (click)="toggleStyle(labelStyleValues.bold)"
            [checked]="hasLabelStyle(labelStyleValues.bold)">
            <mat-icon svgIcon="style_bold"></mat-icon>
          </mat-button-toggle>
          <mat-button-toggle (click)="toggleStyle(labelStyleValues.italic)"
            [checked]="hasLabelStyle(labelStyleValues.italic)">
            <mat-icon svgIcon="style_italic"></mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelSize }}</label>
        <span>{{style.labelSize}}px</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="30"
          [min]="1"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeLabelSize($event)"
          [value]="style.labelSize"
          [label]="labelSize">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.color">Color</label>
        <tm-color-picker [color]="style.labelColor"
        (colorChange)="changeLabelColor($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.halo">Halo</label>
        <tm-color-picker [color]="style.labelOutlineColor"
          [allowEmptyColor]="true"
        (colorChange)="changeLabelOutlineColor($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelRotation }}</label>
        <span>{{style.labelRotation}}&deg;</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="360"
          [min]="0"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeLabelRotation($event)"
          [value]="style.labelRotation"
          [label]="labelRotation">
        </tm-slider>
      </div>
    </mat-expansion-panel>
  }

  @if (showLineSettings()) {
    <mat-expansion-panel class="line-settings settings-section" [expanded]="true">
      <mat-expansion-panel-header i18n="@@core.drawing.line">Line</mat-expansion-panel-header>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.color">Color</label>
        <tm-color-picker [color]="style.strokeColor"
        (colorChange)="changeStrokeColor($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelThickness }}</label>
        <span>{{style.strokeWidth}}px</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="20"
          [min]="1"
          [step]="1"
          [changeValueWhileSliding]="true"
          (valueChange)="changeStrokeWidth($event)"
          [value]="style.strokeWidth"
          [label]="labelThickness">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelOpacity }}</label>
        <span>{{style.strokeOpacity}}%</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="100"
          [min]="0"
          [step]="1"
          [displayWith]="formatThumb"
          [changeValueWhileSliding]="true"
          (valueChange)="changeStrokeOpacity($event)"
          [value]="style.strokeOpacity"
          [label]="labelOpacity">
        </tm-slider>
      </div>

      <mat-form-field appearance="outline" color="primary">
        <mat-label i18n="@@core.drawing.stroke-type">Stroke type</mat-label>
        <mat-select [formControl]="strokeTypeControl"
          panelClass="select-line-style"
          class="select-line-style">
          <mat-select-trigger>
            <ng-container *ngTemplateOutlet="strokeTypeImage; context: { $implicit: style.strokeType }"></ng-container>
          </mat-select-trigger>
          @for (strokeTypeValue of strokeTypeValues; track strokeTypeValue) {
            <mat-option [value]="strokeTypeValue">
              <ng-container *ngTemplateOutlet="strokeTypeImage; context: { $implicit: strokeTypeValue }"></ng-container>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (showArrowSetting()) {
        <mat-form-field appearance="outline" color="primary">
          <label i18n="@@core.drawing.arrow">Arrow</label>
          <mat-select [formControl]="arrowTypeControl">
            @for (arrowTypeValue of arrowTypeValues; track arrowTypeValue.value) {
              <mat-option [value]="arrowTypeValue.value">
                {{arrowTypeValue.label}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isLineType()) {
        <div class="form-field form-field__columns form-field__columns--right-aligned checkbox-field">
          <mat-checkbox labelPosition="before" i18n="@@core.drawing.show-length-along-line"
            [checked]="style.showSegmentSize ?? false"
          (change)="toggleSegmentSize($event)">Show length along line</mat-checkbox>
        </div>
        <div class="form-field form-field__columns form-field__columns--right-aligned checkbox-field">
          <mat-checkbox labelPosition="before" i18n="@@core.drawing.show-total-line-length"
            [checked]="style.showTotalSize ?? false"
          (change)="toggleTotalSize($event)">Show total length of the line</mat-checkbox>
        </div>
      }
    </mat-expansion-panel>
  }

  @if (showPolygonSettings()) {
    <mat-expansion-panel class="polygon-settings settings-section" [expanded]="true">
      <mat-expansion-panel-header i18n="@@core.drawing.fill">Fill</mat-expansion-panel-header>

      <div class="form-field form-field__columns">
        <label i18n="@@core.drawing.color">Color</label>
        <tm-color-picker [color]="style.fillColor"
        (colorChange)="changeFillColor($event)"></tm-color-picker>
      </div>

      <div class="form-field form-field__columns form-field__columns--right-aligned checkbox-field">
        <mat-checkbox labelPosition="before" i18n="@@core.drawing.striped-fill"
          [checked]="style.stripedFill ?? false"
        (change)="changeStripedFill($event)">Striped fill</mat-checkbox>
      </div>

      <div class="form-field form-field__columns">
        <label>{{ labelOpacity }}</label>
        <span>{{style.fillOpacity}}%</span>
      </div>

      <div class="form-field form-field__slider">
        <tm-slider [max]="100"
          [min]="0"
          [step]="1"
          [displayWith]="formatThumb"
          [value]="style.fillOpacity"
          [changeValueWhileSliding]="true"
          (valueChange)="changeFillOpacity($event)"
          [label]="labelOpacity">
        </tm-slider>
      </div>

      <div class="form-field form-field__columns form-field__columns--right-aligned checkbox-field">
        <mat-checkbox labelPosition="before" i18n="@@core.drawing.show-side-length"
          [checked]="style.showSegmentSize ?? false"
        (change)="toggleSegmentSize($event)">Show length along sides</mat-checkbox>
      </div>
      <div class="form-field form-field__columns form-field__columns--right-aligned checkbox-field">
        <mat-checkbox labelPosition="before" i18n="@@core.drawing.show-area-size"
          [checked]="style.showTotalSize ?? false"
        (change)="toggleTotalSize($event)">Show area size</mat-checkbox>
      </div>

    </mat-expansion-panel>
  }

</div>
